














































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";

import { flattenChildrenTree } from "./buildChildrenTree";
import { formatCatalogPrice } from "../utils/formatCatalogPrice";
import { STORE_KEY } from "./_store";

@Component({
  computed: {
    ...mapState(STORE_KEY, ["childrenLoading", "childrenLoaded"]),
    ...mapGetters(STORE_KEY, ["childrenTree"])
  }
})
export default class ProductTypeChildrenTab extends Vue {
  childrenTree!: any[];
  expandedProductIds: Record<string | number, boolean> = {};

  get tableRows() {
    return flattenChildrenTree(
      this.childrenTree || [],
      this.expandedProductIds
    );
  }

  formatPrice(value: any) {
    return formatCatalogPrice(value);
  }

  isExpanded(productId: string | number) {
    return !!this.expandedProductIds[productId];
  }

  toggleProduct(productId: string | number) {
    this.$set(
      this.expandedProductIds,
      productId,
      !this.expandedProductIds[productId]
    );
  }

  rowClass(row: any) {
    switch (row.type) {
      case "product":
        return "catalog-row-product";
      case "container":
        return "catalog-row-container";
      default:
        return "";
    }
  }
}
